import React, {useContext, useRef, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useHistory} from "react-router-dom";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  APOLLO_SYSTEM_ADMIN,
  APOLLO_GROUP_OPERATOR,
  ApolloPageUsagePermission,
} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {isummary_path, post_zeus_campaign_path} from "../../../atom/Apollo_links";
import CampaignFormZeus from "./CampaignFormZeus";
import {ApolloContext} from "../../../atom/Apollo_Context";
import moment from "moment";
import {AdCampaignNew, CampaignZeus, LogRecord} from "./CampaignModelZeus";
import {formatShSchedule, getDefaultSchedule, scheduleArrayToString} from "../../../atom/CAMPAIGN/Apollo_Schedule";
import {formatLogFromSchedule} from "../../../common/PLATFORM/zeus/FunctionZeus";
import {BLANK} from "../ms/common/CommonConst";
import {
  ApolloEventRecord,
  createLogDate,
  createUserLogItemListByOption,
  createUserLogItemListByOptionBool,
  createUserLogItemListByOptionWithNull,
  createUserLogItemListFromArrayAddSB,
  createUserLogItemListFromArrayAddSB2, createUserLogItemListFromCheck2, createUserLogItemListFromDomainSetting,
  createUserLogItemListFromNumber, createUserLogItemListFromNumberWitZeroToBlank,
  createUserLogItemListFromString, createUserLogItemListFromStringValue,
  ItemList, LogData
} from "../../../atom/Apollo_EventRecord";
import {
  Option, options_bidding,
  options_state_edit,
  options_target,
  options_zeus_billing_type, options_zeus_budget_allocation,
  options_zeus_campaign_type, options_zeus_fq_class, options_zeus_fq_term, options_zeus_fq_type, options_zeus_pmp_type,
  valueToOption,
  valueToOptionNull, ZEUS_DELIVERY_TYPE, ZEUS_DOMAIN_SETTING
} from "../../../atom/Apollo_styles";
import {ApolloAxios} from "../../../atom/Apollo_ApiRequest3";
import {getTrackerAudience, getTrackerSetPoint} from "../../../common/Apollo_CommonUtil";
import {ApolloDialog} from "../../../atom/Apollo_Dialog";
import {ApolloConfirmNotActiveDialog} from "../../../organism/HERA/ConfirmNotActiveDialog";

// 画面名：キャンペーン作成（Zeus）
const CampaignCreateZeus = () => {
  const history = useHistory();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {platformaccountid} = useParams<{platformaccountid: string}>();
  const today = moment().startOf("day");
  const [schedule, setSchedule] = useState<boolean[][]>(getDefaultSchedule());
  const campaignData = useRef<CampaignZeus | null>(null);
  const beforeEditRecord = useRef<LogRecord | null>(null);
  const optionAudiences2 = useRef<Option[]>([]);
  const optionSetPoints2 = useRef<Option[]>([]);
  const isExistsNotActiveAudience = useRef<boolean>(false);
  const isExistsNotActiveSetPoint = useRef<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)

  const [showExtAdCampaignBudgetProportion, setShowExtAdCampaignBudgetProportion] = useState<boolean>(false);


  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 23,
    breadId: 2,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const [campaign, setCampaign] = useState<CampaignZeus>({
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: 0,
    adAccountId: Number(platformaccountid),
    name: "",
    status: 2,
    budgetLimitDaily: 100,
    schedule: formatShSchedule(getDefaultSchedule()),
    startDate: today.add(1, "days").format("YYYY-MM-DDTHH:mm"),
    endDate: today.endOf('month').format("YYYY-MM-DDTHH:mm"),
    campaignGoal: -1,
    cpa: 1,
    autoBidding: false,
    extAdCampaignBudgetProportion: 0,
    excludingAudiences: [],
    trackingPoints: [],
    deliveryType: 1,
    billingType: 1,
    pmpType: null,
    fqExist: false,
    fqClass: 1,
    fqTerm: 1,
    fqCount: 1,
    fqType: 1 ,
    budgetAllocation: 1,
    domainSetting: 0,
    adCampaignTargetDomains: [],
    adCampaignExcludingDomains: null,
  });
  const [endDate, setEndDate] = useState(campaign.endDate);
  const [endDateInputType, setEndDateInputType] = useState(2);

  const handleOpenConfirm = () => {
    if (!openConfirmDialog) setOpenConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    if (openConfirmDialog) setOpenConfirmDialog(false)
  }

  const handleSubmit = async (
    optionAudiences: Option[],
    optionSetPoints: Option[],
  ) => {
    isExistsNotActiveAudience.current = false;
    isExistsNotActiveSetPoint.current = false;

    optionAudiences2.current = optionAudiences
    optionSetPoints2.current = optionSetPoints

    if (state.current.trackerId) {
      const localValAudience = await getTrackerAudience(state.current.trackerId);
      if (localValAudience.message !== "") {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: localValAudience.message
          }
        });
        return
      }
      if (localValAudience.result) {
        for (const id of campaign.excludingAudiences) {
          const val = localValAudience?.result?.find(v => v.ID === id)
          if (val?.isActive === false) {
            isExistsNotActiveAudience.current = true;
            break;
          }
        }
      }

      const localValSetPoint = await getTrackerSetPoint(state.current.trackerId);
      if (localValSetPoint.message !== "") {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: localValSetPoint.message
          }
        });
        return
      }
      if (localValSetPoint.result) {
        for (const id of campaign.trackingPoints) {
          const val = localValSetPoint?.result?.find(v => v.ID === id)
          if (val?.isActive === false) {
            isExistsNotActiveSetPoint.current = true;
            break;
          }
        }
      }
    }

    if (isExistsNotActiveAudience.current || isExistsNotActiveSetPoint.current) {
      handleOpenConfirm();
      return;
    }

    await handleSubmitExecute();
  };

  const handleSubmitExecute = async() => {
    // 作成API実行・操作履歴ログ格納
    let isSuccess = false;
    const newStartDate = moment(campaign.startDate);
    const newEndDate = endDateInputType === 1 ? null : moment(endDate);
    const excludingAudienceNames: string[] = [];
    const trackingPointNames: string[] = [];

    campaign.excludingAudiences.map((id: number) => {
      if(valueToOptionNull(id, optionAudiences2.current)) {
        excludingAudienceNames.push(valueToOption(id, optionAudiences2.current).label);
      }
    });

    campaign.trackingPoints.map((id: number) => {
      if(valueToOptionNull(id, optionSetPoints2.current)) {
        trackingPointNames.push(valueToOption(id, optionSetPoints2.current).label);
      }
    });

    beforeEditRecord.current = {
      adAccountId: Number(platformaccountid),
      name: "",
      status: null,
      budgetLimitDaily: null,
      schedule: [],
      startDate: "",
      endDate: "",
      campaignGoal: null,
      cpa: null,
      autoBidding: null,
      extAdCampaignBudgetProportion: 0,
      excludingAudiences: [],
      excludingAudienceNames: [],
      trackingPoints: [],
      trackingPointNames: [],
      deliveryType: 0,
      billingType: 0,
      adCampaignExcludingDomains: [],
      pmpType: 0,
      fqExist: false,
      fqClass: 0,
      fqTerm: 0,
      fqType: 0,
      fqCount: 0,
      budgetAllocation: 0,
      domainSetting: 0,
      adCampaignTargetDomains: [],
    }

    const body: AdCampaignNew = {
      adAccountId: campaign.adAccountId,
      name: campaign.name,
      status: campaign.status,
      budgetLimitDaily: campaign.budgetLimitDaily,
      schedule: scheduleArrayToString(schedule),
      startDate: newStartDate.format(),
      endDate: newEndDate ? newEndDate.format(): newEndDate,
      campaignGoal: campaign.campaignGoal,
      cpa: campaign.cpa ?? 0,
      autoBidding: campaign.autoBidding,
      extAdCampaignBudgetProportion: campaign.extAdCampaignBudgetProportion ?? 0,
      excludingAudiences: campaign.excludingAudiences,
      pmpType: campaign.pmpType,
      fqClass: campaign.fqExist? campaign.fqClass : null,
      fqTerm: campaign.fqExist? campaign.fqTerm : null,
      fqCount: campaign.fqExist? campaign.fqCount : null,

      // フリークエンシーキャップ項目は「1：vimp固定」で送信
      fqType: campaign.fqExist? 1 : null,

      budgetAllocation: campaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? campaign.budgetAllocation : null,
      domainSetting: campaign.domainSetting,
      trackingPoints: campaign.trackingPoints,
      deliveryType: campaign.deliveryType,
      adCampaignExcludingDomains: campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION ? campaign.adCampaignExcludingDomains?.filter(x => x !== "") ?? [] : [],
      adCampaignTargetDomains: campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION ? campaign.adCampaignTargetDomains?.filter(x => x !== "") ?? [] : [],
    }

    const executeLog = createUserLog(
      state,
      "パフォーマンス広告",
      "キャンペーン",
      "作成",
      "キャンペーン（パフォーマンス広告）作成",
      beforeEditRecord.current,
      {
        adAccountId: Number(platformaccountid),
        name: campaign.name,
        status: campaign.status,
        budgetLimitDaily: campaign.budgetLimitDaily,
        schedule: formatLogFromSchedule(body.schedule ?? ""),
        startDate: `${newStartDate.format("YYYY-MM-DD HH:mm")}`,
        endDate: newEndDate ? `${newEndDate.format("YYYY-MM-DD HH:mm")}` : "継続的配信",
        campaignGoal: campaign.campaignGoal,
        cpa: campaign.cpa ?? 0,
        autoBidding: campaign.autoBidding,
        extAdCampaignBudgetProportion: campaign.extAdCampaignBudgetProportion,
        excludingAudiences: campaign.excludingAudiences,
        excludingAudienceNames: excludingAudienceNames,
        trackingPoints: campaign.trackingPoints,    
        trackingPointNames: trackingPointNames,
        deliveryType: campaign.deliveryType,
        billingType: campaign.billingType,
        adCampaignExcludingDomains: campaign.domainSetting == 0 ? [] : campaign.adCampaignExcludingDomains,
        pmpType: campaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? campaign.pmpType : 0,
        fqExist: campaign.fqExist,
        fqClass: campaign.fqExist ? campaign.fqClass : 0,
        fqTerm: campaign.fqExist ? campaign.fqTerm : 0,
        fqType: campaign.fqExist ? 1 : 0,
        fqCount: campaign.fqExist ? campaign.fqCount : 0,
        budgetAllocation: campaign.deliveryType == 2 ? campaign.budgetAllocation : 0,
        domainSetting: campaign.deliveryType == ZEUS_DELIVERY_TYPE.DSP ? campaign.domainSetting : 0,
        adCampaignTargetDomains: campaign.domainSetting == 0 ? [] : campaign.adCampaignTargetDomains,
      },
      BLANK, // キャンペーンID
      BLANK, // キャンペーン名
      BLANK, // 広告グループID
      BLANK, // 広告グループ名
    );
    ApolloEventRecord({...executeLog, logType: "execute"});

    let registedId = BLANK

    ApolloAxios.post(post_zeus_campaign_path, body).then(response => {
      if (response.status !== 200) {
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "キャンペーンの作成に失敗しました",
        });
      } else {
        registedId = response.data.id?.toString() ?? BLANK;
      }

      isSuccess = true;
      campaignData.current = campaign;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "キャンペーンを作成しました",
        }
      });

    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executeLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        targetID: registedId,
        targetName: campaignData.current? campaignData.current?.name: "",
        result: isSuccess ? "成功" : "失敗",
        campaignID: registedId,
        campaignName: campaignData.current? campaignData.current?.name: "",
      };
      ApolloEventRecord({...resultLog, logType: "result"});
      if(isSuccess) {
        window.scrollTo(0, 0);
        history.push(isummary_path);
      }
    });
  };

  const handleGoBack = () => {
    // キャンセルボタンクリック時のアクション
    history.push(isummary_path);
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <CampaignFormZeus
          campaignId={0}
          campaignState={{
            campaign: campaign,
            setCampaign: setCampaign,
          }}
          scheduleState={{
            schedule: schedule,
            setSchedule: setSchedule,
          }}
          endDateState={{
            endDate: endDate,
            setEndDate: setEndDate,
            endDateInputType: endDateInputType,
            setEndDateInputType: setEndDateInputType,
          }}
          submitAction={handleSubmit}
          goBackAction={handleGoBack}        
          showExtAdCampaignBudgetProportion={showExtAdCampaignBudgetProportion}
          setShowExtAdCampaignBudgetProportion={setShowExtAdCampaignBudgetProportion}
          beforeStartDate={""}
        />
      </ApolloPageUsagePermission>
      <ApolloDialog open={openConfirmDialog} setOpen={setOpenConfirmDialog}>
        <ApolloConfirmNotActiveDialog
          isExistsNotActiveAudience={isExistsNotActiveAudience.current}
          isExistsNotActiveSetPoint={isExistsNotActiveSetPoint.current}
          handleSave={handleSubmitExecute}
          handleClose={handleCloseConfirm}
        />
      </ApolloDialog>
    </GenericTemplate>
  )
};

const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
  campaignId?: string,
  campaignName?: string,
  adGroupId?: string,
  adGroupName?: string,
) => {
  const items: ItemList[] = [
    createUserLogItemListFromNumber("プラットフォームアカウントID", "adAccountId", beforeInfo, afterInfo),
    createUserLogItemListByOption("キャンペーン種別", "deliveryType", beforeInfo, afterInfo, options_zeus_campaign_type),
    createUserLogItemListByOption("課金種別", "billingType", beforeInfo, afterInfo, options_zeus_billing_type),
    createUserLogItemListFromString("キャンペーン名", "name", beforeInfo, afterInfo),
    createUserLogItemListByOption("ステータス", "status", beforeInfo, afterInfo, options_state_edit),
    createUserLogItemListFromNumber(  "日予算額", "budgetLimitDaily", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("掲載スケジュール", "schedule", beforeInfo, afterInfo),
    createUserLogItemListFromString("掲載期間_開始", "startDate", beforeInfo, afterInfo),
    createUserLogItemListFromString("掲載期間_終了", "endDate", beforeInfo, afterInfo),
    createUserLogItemListByOption("キャンペーンの目的", "campaignGoal", beforeInfo, afterInfo, options_target),
    createUserLogItemListFromNumber(  "目標獲得単価", "cpa", beforeInfo, afterInfo),
    createUserLogItemListByOptionBool("入札戦略", "autoBidding", beforeInfo, afterInfo, options_bidding),
    createUserLogItemListByOptionWithNull("取引形式", "pmpType", beforeInfo, afterInfo, options_zeus_pmp_type),
    createUserLogItemListFromCheck2("フリークエンシーキャップ設定有無", "fqExist", beforeInfo, afterInfo, ),
    createUserLogItemListByOption("フリークエンシーキャップ階層", "fqClass", beforeInfo, afterInfo, options_zeus_fq_class),
    createUserLogItemListByOption("フリークエンシーキャップ期間", "fqTerm", beforeInfo, afterInfo, options_zeus_fq_term),
    createUserLogItemListByOption("フリークエンシーキャップ項目", "fqType", beforeInfo, afterInfo, options_zeus_fq_type),
    createUserLogItemListFromNumberWitZeroToBlank("フリークエンシーキャップ回数", "fqCount", beforeInfo, afterInfo),
    createUserLogItemListByOption("予算配分", "budgetAllocation", beforeInfo, afterInfo, options_zeus_budget_allocation),
    createUserLogItemListFromNumber("外部配信予算割合", "extAdCampaignBudgetProportion", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("オーディエンス除外設定", "excludingAudienceNames", beforeInfo, afterInfo),
    createUserLogItemListFromDomainSetting("配信先ドメイン除外/指定選択", "domainSetting", beforeInfo, afterInfo ),
    createUserLogItemListFromArrayAddSB2("配信先ドメイン除外設定", "adCampaignExcludingDomains", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB2("配信先ドメイン指定設定", "adCampaignTargetDomains", beforeInfo, afterInfo),
    createUserLogItemListFromArrayAddSB("測定ポイント設定", "trackingPointNames", beforeInfo, afterInfo),
  ];

  const retObj = createLogDate(
    apolloContex,
    menu,
    category,
    actionType,
    displayName,
    items,
    campaignId,
    campaignName,
    adGroupId,
    adGroupName,
  );

  return retObj
}

export default CampaignCreateZeus;
